export default __webpack_public_path__ + "static/media/briefcase-check.e4f8c89d.svg";